export default function setSelectedFiles({ props, state, path }) {
  const files = state.get('media.files')

  let selectedFiles = Object.keys(files).reduce((acc, fileKey) => {
    if (files[fileKey].selected) {
      acc.push(fileKey)
    }
    return acc
  }, [])

  state.set('media.selectedFiles', selectedFiles)
}



// WEBPACK FOOTER //
// ./src/modules/Media/actions/setSelectedFiles.js